export const templesGroup4 = [
  {
    slNo: "39",
    slug: "bajreshwari-devi-kangra",
    generalInfo: {
      templeName: "Shri Bajreshwari Devi Temple",
      templeDescription: "Shri Bajreshwari Devi Temple in Kangra is a historic Shakti shrine administered through Himachal Pradesh's temple-management system. The Goddess is worshipped in pindi form inside a fortified temple complex. The administration publishes separate summer and winter opening and aarti schedules with a short midday bhog closure. Navaratri and Makar Sankranti attract large fairs and special rituals, and free langar is provided twice daily.",
      location: "Kangra, Himachal Pradesh",
      deity: "Maa Bajreshwari / Vajreshwari Devi",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Navaratri and Makar Sankranti"
    },
    footfall: {
      monthlyFootfalls: [
        { month: "Annual Total", totalYatra: "701,000" }
      ]
    },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "16", low: "5" },
        { month: "Feb", high: "18", low: "7" },
        { month: "Mar", high: "23", low: "11" },
        { month: "Apr", high: "28", low: "15" },
        { month: "May", high: "32", low: "19" },
        { month: "Jun", high: "32", low: "22" },
        { month: "Jul", high: "28", low: "22" },
        { month: "Aug", high: "27", low: "21" },
        { month: "Sep", high: "27", low: "19" },
        { month: "Oct", high: "25", low: "14" },
        { month: "Nov", high: "21", low: "9" },
        { month: "Dec", high: "17", low: "6" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:00 AM",
        morningClose: "12:00 PM for Bhog",
        eveningOpen: "12:30 PM",
        eveningClose: "09:30 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Morning Aarti", time: "Winter: 06:00-07:00 AM; Summer: 05:30-06:00 AM" },
        { name: "Bhog", time: "12:00 PM - 12:30 PM" },
        { name: "Evening Aarti", time: "07:30 PM - 08:00 PM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Kangra Airport, Gaggal", endPoint: "Bajreshwari Devi Temple", distanceKm: 9, duration: "Approx. 20 mins", cost: "N/A" },
      { mode: "Train", startPoint: "Kangra Railway Station", endPoint: "Temple", distanceKm: 3, duration: "Approx. 10 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Dharamshala", location: "Kangra temple area", costRange: "Varies", bookingInfo: "Pilgrim lodges available." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Cloakroom facilities available around temple approach.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear storage available.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Free langar twice daily.", isAvailable: true },
      { name: "Prasad", description: "Temple prasad available.", isAvailable: true }
    ],
    specialServices: [
      { name: "Free Langar", description: "Temple provides free langar twice daily." }
    ],
    nearbyPlaces: [
      { name: "Kangra Fort", description: "Major historic fort near Kangra." },
      { name: "Jwala Ji Temple", description: "Approx. 35 km away." }
    ],
    images: { thumbnailImage: "https://tourism-kangra.weebly.com/uploads/3/0/2/3/30239281/7418219_orig.jpg" },
    management: {
      trustName: "Shri Bajreshwari Mata Temple Administration",
      website: "https://kangratemples.hp.gov.in/shri-bajreshwari-mata-temple/",
      contactNumber: "01892-265073"
    }
  },
  {
    slNo: "40",
    slug: "chamunda-devi-kangra",
    generalInfo: {
      templeName: "Chamunda Devi Temple, Kangra",
      templeDescription: "Chamunda Devi Temple on the Baner River near Dharamshala is a major Shakti shrine dedicated to the fierce form of Goddess Chamunda. The Himachal temple administration publishes seasonal darshan schedules and daily aarti times, with a midday closure and free langar. The temple is reached by road and lies roughly 15-20 km from Dharamshala.",
      location: "Chamunda, Kangra, Himachal Pradesh",
      deity: "Goddess Chamunda Devi",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Navaratri and summer holiday weekends"
    },
    footfall: {
      monthlyFootfalls: [
        { month: "Annual Total", totalYatra: "507,000" }
      ]
    },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "16", low: "5" },
        { month: "Feb", high: "18", low: "7" },
        { month: "Mar", high: "23", low: "11" },
        { month: "Apr", high: "28", low: "15" },
        { month: "May", high: "32", low: "19" },
        { month: "Jun", high: "32", low: "22" },
        { month: "Jul", high: "28", low: "22" },
        { month: "Aug", high: "27", low: "21" },
        { month: "Sep", high: "27", low: "19" },
        { month: "Oct", high: "25", low: "14" },
        { month: "Nov", high: "21", low: "9" },
        { month: "Dec", high: "17", low: "6" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:00 AM summer / 06:00 AM winter",
        morningClose: "12:00 PM",
        eveningOpen: "01:00 PM",
        eveningClose: "10:00 PM summer / 09:00 PM winter"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Morning Aarti", time: "Approx. 08:00-08:45 AM" },
        { name: "Evening Aarti", time: "Approx. 07:10-07:50 PM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Kangra Airport, Gaggal", endPoint: "Chamunda Devi Temple", distanceKm: 18, duration: "Approx. 35-45 mins", cost: "N/A" },
      { mode: "Bus", startPoint: "Dharamshala Bus Stand", endPoint: "Chamunda Devi Temple", distanceKm: 15, duration: "Approx. 30-45 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "Hotel Vatika, approx. 0.4 km from temple", costRange: "Verify tariff", bookingInfo: "Near temple." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Cloakroom/locker facility available near shrine.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear storage available.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available in pilgrim complex.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Free temple langar served daily: 12:00-02:00 PM and 07:00-09:00 PM.", isAvailable: true, price: "Free langar" },
      { name: "Prasad", description: "Temple prasad available.", isAvailable: true }
    ],
    specialServices: [
      { name: "Free Langar", description: "Lunch 12:00-02:00 PM; dinner 07:00-09:00 PM." }
    ],
    nearbyPlaces: [
      { name: "Dharamshala", description: "Major hill town about 15 km away." },
      { name: "Chinmaya Tapovan", description: "Spiritual centre near Dharamshala." }
    ],
    images: { thumbnailImage: "https://www.beingpahadia.com/wp-content/uploads/2020/02/chamundaji-min.jpg" },
    management: {
      trustName: "Chamunda Devi Temple Administration",
      website: "https://kangratemples.hp.gov.in/",
      contactNumber: "01892-236034"
    }
  },
  {
    slNo: "41",
    slug: "kollur-mookambika",
    generalInfo: {
      templeName: "Kollur Mookambika Temple",
      templeDescription: "Kollur Mookambika Temple is a major Shakti shrine at the foot of the Western Ghats in Karnataka, dedicated to Goddess Mookambika. The temple follows a detailed daily pooja sequence beginning early in the morning, with a midday closure and evening worship until about 9 PM. Vidyarambha, Chandika Homa and other sevas are especially important here. Navaratri is the peak pilgrimage period.",
      location: "Kollur, Udupi District, Karnataka",
      deity: "Goddess Mookambika",
      trekPoints: [],
      dressCode: "Traditional/modest clothing recommended."
    },
    timeInfo: {
      bestTime: "August - February",
      peakTime: "Navaratri / Dussehra and school-opening Vidyarambha periods"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "32", low: "20" },
        { month: "Feb", high: "33", low: "21" },
        { month: "Mar", high: "33", low: "23" },
        { month: "Apr", high: "33", low: "24" },
        { month: "May", high: "32", low: "24" },
        { month: "Jun", high: "28", low: "23" },
        { month: "Jul", high: "27", low: "22" },
        { month: "Aug", high: "27", low: "22" },
        { month: "Sep", high: "28", low: "22" },
        { month: "Oct", high: "29", low: "22" },
        { month: "Nov", high: "30", low: "21" },
        { month: "Dec", high: "31", low: "20" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:00 AM",
        morningClose: "01:30 PM",
        eveningOpen: "03:00 PM",
        eveningClose: "09:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Lingam Abhishekam", time: "05:15 AM" },
        { name: "Ganahoma", time: "05:30 AM" },
        { name: "Maha Mangalarathi", time: "Around 12:30 PM" },
        { name: "Kashaya Mangalarathi", time: "09:00 PM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Mangalore International Airport", endPoint: "Kollur", distanceKm: 125, duration: "Approx. 2-3 hrs", cost: "₹2800-₹3400 by taxi" },
      { mode: "Train", startPoint: "Byndoor Mookambika Road Station", endPoint: "Kollur", distanceKm: 28, duration: "Approx. 45 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "Hotel Mookambika Palace, Kollur", costRange: "Check current tariff", bookingInfo: "In Kollur temple town." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Paid cloakroom/locker services available in town.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear deposit available.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking-water facilities available.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Mahalaxmi Veg Restaurant and eateries operate beside shrine.", isAvailable: true },
      { name: "Prasad", description: "Temple prasadam available.", isAvailable: true }
    ],
    specialServices: [
      { name: "Chandika Homa", description: "Major temple seva.", price: "Approx. ₹8,000" },
      { name: "Vidyarambha", description: "Initiation-of-learning ritual for children.", price: "Approx. ₹200" }
    ],
    nearbyPlaces: [
      { name: "Kodachadri Hills", description: "Major Western Ghats trekking/pilgrimage destination near Kollur." },
      { name: "Mookambika Wildlife Sanctuary", description: "Surrounding forest and wildlife area." }
    ],
    images: { thumbnailImage: "https://hel1.your-objectstorage.com/goodpass/placexplore-5c53f59c/products/65320ac8587afcb3c4ab367d/images/a03d9475-c4d0-4547-8de4-58ea9f4b0d5d.jpg" },
    management: {
      trustName: "Sri Mookambika Temple - Karnataka HR&CE",
      website: "https://itms.kar.nic.in/hrcehome/index_temple.php?tid=62",
      contactNumber: "08254-200200"
    }
  },
  {
    slNo: "42",
    slug: "udupi-sri-krishna",
    generalInfo: {
      templeName: "Udupi Sri Krishna Matha",
      templeDescription: "Udupi Sri Krishna Matha is the principal Krishna shrine of Udupi and a central institution of the Dvaita Vedanta tradition founded by Madhvacharya. Devotees traditionally view Lord Krishna through the nine-holed Navagraha Kindi. The temple follows morning and evening darshan sessions and is closely associated with the eight Udupi mathas and the biennial Paryaya tradition. Daily Anna Dasoha provides meals to pilgrims.",
      location: "Udupi, Karnataka",
      deity: "Lord Krishna",
      trekPoints: [],
      dressCode: "Traditional/modest clothing recommended; follow matha instructions in inner worship areas."
    },
    timeInfo: {
      bestTime: "October - February",
      peakTime: "Paryaya festival, Krishna Janmashtami and school holidays"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "32", low: "21" },
        { month: "Feb", high: "32", low: "22" },
        { month: "Mar", high: "32", low: "24" },
        { month: "Apr", high: "32", low: "25" },
        { month: "May", high: "31", low: "25" },
        { month: "Jun", high: "28", low: "24" },
        { month: "Jul", high: "27", low: "23" },
        { month: "Aug", high: "27", low: "23" },
        { month: "Sep", high: "28", low: "23" },
        { month: "Oct", high: "29", low: "23" },
        { month: "Nov", high: "30", low: "23" },
        { month: "Dec", high: "31", low: "22" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:00 AM",
        morningClose: "01:00 PM",
        eveningOpen: "03:30 PM",
        eveningClose: "09:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Morning Pooja", time: "From 05:00 AM" },
        { name: "Evening Pooja", time: "03:30 PM - 09:00 PM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Mangalore International Airport", endPoint: "Udupi", distanceKm: 52.3, duration: "Approx. 50-75 mins", cost: "₹1200-₹1500 by taxi" },
      { mode: "Train", startPoint: "Udupi Railway Station", endPoint: "Sri Krishna Matha", distanceKm: 4, duration: "Approx. 15 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "Kinara Executive Lodge, approx. 0.3 km", costRange: "Verify tariff", bookingInfo: "Central Udupi." }
    ],
    gates: [],
    facilities: [
      { name: "Shoe Stand", description: "Footwear storage available.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available.", isAvailable: true },
      { name: "Toilets", description: "Pilgrim toilets available around matha complex.", isAvailable: true },
      { name: "Restaurants / Food", description: "Daily free Anna Dasoha meals served around 11:30 AM and 07:30 PM.", isAvailable: true },
      { name: "Prasad", description: "Temple prasadam available.", isAvailable: true }
    ],
    specialServices: [
      { name: "Anna Dasoha", description: "Free community meals served daily at 11:30 AM and 07:30 PM." }
    ],
    nearbyPlaces: [
      { name: "Chandramouleshwara Temple", description: "Historic Shiva temple adjacent to Krishna Matha." },
      { name: "Malpe Beach", description: "Coastal destination about 6 km away." }
    ],
    images: { thumbnailImage: "https://cdn.travelpal.ai/prod/places/WgUTqCY-TKVCu6oyefMZMNVw8lA/photos/google/webp/c355e3fc10c4f5b670c08353.webp" },
    management: {
      trustName: "Sri Krishna Matha, Udupi / Paryaya Peethadhipathi",
      website: "https://shrikrishnamatha.org/",
      contactNumber: "+91 820 252 0598"
    }
  },
  {
    slNo: "43",
    slug: "kukke-subrahmanya",
    generalInfo: {
      templeName: "Kukke Shri Subrahmanya Temple",
      templeDescription: "Kukke Shri Subrahmanya Temple in Dakshina Kannada is a major pilgrimage shrine dedicated to Lord Subrahmanya and is especially known for Sarpa Samskara, Naga Pratishta and Ashlesha Bali rituals. Men are expected to remove shirts/vests in inner worship areas. The temple provides RO water, toilets, cloakrooms, accommodation and battery-car assistance.",
      location: "Kukke Subrahmanya, Dakshina Kannada, Karnataka",
      deity: "Lord Subrahmanya with Vasuki",
      trekPoints: [],
      dressCode: "Men remove shirt/banian for inner darshan; modest traditional clothing for all."
    },
    timeInfo: {
      bestTime: "October - February",
      peakTime: "Subrahmanya Shashti and high-demand Sarpa Samskara dates"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "33", low: "20" },
        { month: "Feb", high: "34", low: "21" },
        { month: "Mar", high: "34", low: "23" },
        { month: "Apr", high: "34", low: "24" },
        { month: "May", high: "32", low: "24" },
        { month: "Jun", high: "27", low: "23" },
        { month: "Jul", high: "26", low: "22" },
        { month: "Aug", high: "27", low: "22" },
        { month: "Sep", high: "28", low: "22" },
        { month: "Oct", high: "29", low: "22" },
        { month: "Nov", high: "31", low: "21" },
        { month: "Dec", high: "32", low: "20" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "06:30 AM",
        morningClose: "01:30 PM",
        eveningOpen: "03:30 PM",
        eveningClose: "09:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Tulabhara Seva", time: "10:30 AM - 11:00 AM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Mangalore International Airport", endPoint: "Kukke", distanceKm: 105.9, duration: "Approx. 1.5-2.5 hrs", cost: "₹2300-₹2900 by taxi" },
      { mode: "Train", startPoint: "Subrahmanya Road Railway Station", endPoint: "Temple", distanceKm: 12, duration: "Approx. 25 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "The Aurum Subrahmanya, very close to temple", costRange: "Verify tariff", bookingInfo: "Close to temple." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Temple cloakroom facilities available.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear stand available.", isAvailable: true },
      { name: "Drinking Water", description: "RO drinking-water facility available.", isAvailable: true },
      { name: "Toilets", description: "Temple toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Temple Anna Santharpane plus vegetarian eateries.", isAvailable: true },
      { name: "Prasad", description: "Theertha/prasada distributed after pooja.", isAvailable: true },
      { name: "Wheelchair", description: "Battery cars and assistance available for elderly pilgrims.", isAvailable: true }
    ],
    specialServices: [
      { name: "Sarpa Samskara + Naga Pratishta", description: "Major two-day ritual; advance booking recommended.", price: "Approx. ₹4,200" },
      { name: "Ashlesha Bali", description: "Popular ritual for snake dosha.", price: "Approx. ₹400" }
    ],
    nearbyPlaces: [
      { name: "Adi Subrahmanya Temple", description: "Important subsidiary shrine near Kukke." },
      { name: "Kumaradhara River", description: "Sacred river/bathing area near temple." }
    ],
    images: { thumbnailImage: "https://2.bp.blogspot.com/-wGdYxluUmGA/VFZeIGlidSI/AAAAAAAACI8/wLesQ8w7l1I/s1600/1.jpg" },
    management: {
      trustName: "Kukke Shri Subrahmanya Temple - Karnataka HR&CE",
      website: "https://itms.kar.nic.in/hrcehome/",
      contactNumber: "08257-281224"
    }
  },
  {
    slNo: "44",
    slug: "dharmasthala-manjunatha",
    generalInfo: {
      templeName: "Shri Manjunatha Temple, Dharmasthala",
      templeDescription: "Dharmasthala is a major Karnataka pilgrimage centre where Lord Manjunatha (Shiva) is worshipped under the hereditary Dharmadhikari tradition of the Heggade family. The temple combines Shaiva worship with Jain administration traditions and is renowned for free meals served to pilgrims in the Annapurna dining hall.",
      location: "Dharmasthala, Dakshina Kannada, Karnataka",
      deity: "Lord Manjunatha (Shiva)",
      trekPoints: [],
      dressCode: "Men remove shirt/banian in prescribed sanctum area; no half pants. Women should avoid nighties/revealing clothing."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Maha Shivaratri, Laksha Deepotsava and holiday periods"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [
      { name: "Children Restriction", description: "Children below 2 years may be restricted from the sanctum." }
    ],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "33", low: "20" },
        { month: "Feb", high: "34", low: "21" },
        { month: "Mar", high: "34", low: "23" },
        { month: "Apr", high: "34", low: "24" },
        { month: "May", high: "32", low: "24" },
        { month: "Jun", high: "27", low: "23" },
        { month: "Jul", high: "26", low: "22" },
        { month: "Aug", high: "27", low: "22" },
        { month: "Sep", high: "28", low: "22" },
        { month: "Oct", high: "29", low: "22" },
        { month: "Nov", high: "31", low: "21" },
        { month: "Dec", high: "32", low: "20" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "06:30 AM",
        morningClose: "11:00 AM",
        eveningOpen: "12:15 PM - 02:30 PM; again 05:00 PM",
        eveningClose: "08:30 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Shatharudra Abhisheka", time: "08:30 AM - 10:30 AM" },
        { name: "Mahapooja", time: "12:00 PM" },
        { name: "Evening Mahapooja", time: "08:30 PM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Mangalore International Airport", endPoint: "Dharmasthala", distanceKm: 75, duration: "Approx. 1.5-2.5 hrs", cost: "N/A" },
      { mode: "Train", startPoint: "Mangalore Junction", endPoint: "Dharmasthala", distanceKm: 66.9, duration: "Approx. 1-1.5 hrs", cost: "₹1500-₹1800 by taxi" }
    ],
    accommodation: [
      { type: "Temple Guest House", location: "Sannidhi / Netravathi / Gayathri", costRange: "Nominal tariff", bookingInfo: "Capacity for over 30,000 pilgrims." }
    ],
    gates: [],
    facilities: [
      { name: "Shoe Stand", description: "Footwear storage available.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available.", isAvailable: true },
      { name: "Toilets", description: "Restrooms available throughout facilities.", isAvailable: true },
      { name: "Restaurants / Food", description: "Free meals at Annapurna dining hall for all visitors.", isAvailable: true, price: "Free Annaprasadam" },
      { name: "Prasad", description: "Temple prasad available.", isAvailable: true },
      { name: "Medical Facility", description: "SDM medical facilities provide emergency support.", isAvailable: true }
    ],
    specialServices: [
      { name: "Free Annapurna Meals", description: "Free lunch and dinner served daily to all pilgrims." },
      { name: "Manjusha Museum", description: "Museum of cultural and historical artefacts." }
    ],
    nearbyPlaces: [
      { name: "Bahubali Statue", description: "Large monolithic statue in Dharmasthala." },
      { name: "Netravathi River Barrage", description: "Local river attraction." }
    ],
    images: { thumbnailImage: "https://viharadarshani.in/wp-content/uploads/2025/01/Dharmasthala-manjunatha-swamy-Temple.jpg" },
    management: {
      trustName: "Shri Kshetra Dharmasthala / Dharmadhikari",
      website: "https://www.shridharmasthala.org/",
      contactNumber: "08256-266666"
    }
  },
  {
    slNo: "45",
    slug: "kanaka-durga-vijayawada",
    generalInfo: {
      templeName: "Kanaka Durga Temple",
      templeDescription: "Kanaka Durga Temple, officially Sri Durga Malleswara Swamy Varla Devasthanam, is located on Indrakeeladri hill overlooking the Krishna River in Vijayawada. The temple is dedicated to Goddess Kanaka Durga and is one of Andhra Pradesh's most important Devi shrines. General darshan is free, while paid darshan and sevas can be booked through the temple system. Dasara is the peak period.",
      location: "Vijayawada, Andhra Pradesh",
      deity: "Goddess Kanaka Durga",
      trekPoints: [],
      dressCode: "Modest traditional clothing; shorts, mini-skirts, revealing clothing not permitted."
    },
    timeInfo: {
      bestTime: "October - February",
      peakTime: "Dasara / Navaratri"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "30", low: "19" },
        { month: "Feb", high: "33", low: "21" },
        { month: "Mar", high: "36", low: "24" },
        { month: "Apr", high: "38", low: "27" },
        { month: "May", high: "40", low: "29" },
        { month: "Jun", high: "36", low: "28" },
        { month: "Jul", high: "33", low: "26" },
        { month: "Aug", high: "33", low: "26" },
        { month: "Sep", high: "33", low: "25" },
        { month: "Oct", high: "32", low: "24" },
        { month: "Nov", high: "30", low: "22" },
        { month: "Dec", high: "29", low: "19" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:00 AM",
        morningClose: "Open through day (Thursday ritual closures)",
        eveningOpen: "Open through day",
        eveningClose: "09:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Daily Pooja / Darshan", time: "Multiple sessions from early morning" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Vijayawada International Airport", endPoint: "Kanaka Durga", distanceKm: 20.9, duration: "Approx. 20-40 mins", cost: "₹470-₹600 by taxi" },
      { mode: "Train", startPoint: "Vijayawada Junction", endPoint: "Kanaka Durga", distanceKm: 4, duration: "Approx. 10-20 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Temple Accommodation", location: "Devasthanam guest accommodation", costRange: "Tariff varies", bookingInfo: "Book through temple portal." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Paid cloakroom facility available.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear storage available.", isAvailable: true },
      { name: "Drinking Water", description: "Free drinking-water facilities available.", isAvailable: true },
      { name: "Toilets", description: "Free public toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Temple free-meal facilities plus restaurants in city.", isAvailable: true },
      { name: "Prasad", description: "Free and paid prasadam services available.", isAvailable: true }
    ],
    specialServices: [
      { name: "Free Meals", description: "Devasthanam provides free meals daily." }
    ],
    nearbyPlaces: [
      { name: "Prakasam Barrage", description: "Krishna River barrage near temple." },
      { name: "Undavalli Caves", description: "Historic rock-cut caves near Vijayawada." }
    ],
    images: { thumbnailImage: "https://yatradham.org/media/catalog/product/i/m/img_9988.jpg" },
    management: {
      trustName: "Sri Durga Malleswara Swamy Varla Devasthanam",
      website: "https://kanakadurgamma.org/",
      contactNumber: "+91-(0866)-2423500; +91 9441820717"
    }
  },
  {
    slNo: "46",
    slug: "srisailam-mallikarjuna",
    generalInfo: {
      templeName: "Sri Mallikarjuna Swamy Temple, Srisailam",
      templeDescription: "Sri Mallikarjuna Swamy Temple at Srisailam is one of the twelve Jyotirlingas and, together with the Bhramaramba shrine, one of India's important Shiva-Shakti pilgrimage complexes. The Devasthanam operates online booking for darshan, sevas and accommodation. General darshan begins early in the morning, with paid Seeghra and Athi Seeghra options.",
      location: "Srisailam, Andhra Pradesh",
      deity: "Lord Mallikarjuna (Shiva) and Goddess Bhramaramba",
      trekPoints: [],
      dressCode: "Traditional Hindu clothing required for sevas; avoid modern/revealing or sleeveless clothing."
    },
    timeInfo: {
      bestTime: "October - February",
      peakTime: "Maha Shivaratri, Ugadi and weekends/holidays"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "29", low: "16" },
        { month: "Feb", high: "32", low: "18" },
        { month: "Mar", high: "35", low: "21" },
        { month: "Apr", high: "38", low: "24" },
        { month: "May", high: "39", low: "25" },
        { month: "Jun", high: "33", low: "24" },
        { month: "Jul", high: "30", low: "23" },
        { month: "Aug", high: "30", low: "23" },
        { month: "Sep", high: "30", low: "22" },
        { month: "Oct", high: "30", low: "21" },
        { month: "Nov", high: "28", low: "18" },
        { month: "Dec", high: "27", low: "16" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "06:00 AM",
        morningClose: "Approx. 03:30 PM",
        eveningOpen: "06:00 PM",
        eveningClose: "10:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Suprabhatha Darshan", time: "Approx. 05:00 AM" },
        { name: "Mahamangala Aarti", time: "Approx. 05:30 AM" },
        { name: "Evening Aarti", time: "Approx. 05:00 PM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Rajiv Gandhi International Airport, Hyderabad", endPoint: "Srisailam", distanceKm: 195.8, duration: "Approx. 3-4 hrs", cost: "₹4500-₹5500 by taxi" },
      { mode: "Train", startPoint: "Markapur Road Railway Station", endPoint: "Srisailam", distanceKm: 85, duration: "Approx. 2-3 hrs", cost: "N/A" }
    ],
    accommodation: [
      { type: "Devasthanam Accommodation", location: "Guest houses/cottages, Srisailam", costRange: "Tariff varies", bookingInfo: "Book through Srisaila Devasthanam portal." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Cloakroom available for bags, mobiles and cameras.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear storage available.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking-water facilities available.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Temple prasadam and annadanam plus local eateries.", isAvailable: true },
      { name: "Medical Facility", description: "Devasthanam hospital with ambulance care operates onsite.", isAvailable: true }
    ],
    specialServices: [
      { name: "Seeghra Darshan", description: "Faster darshan through booking.", price: "₹150" },
      { name: "Athi Seeghra Darshan", description: "Higher-tier faster darshan through booking.", price: "₹500" }
    ],
    nearbyPlaces: [
      { name: "Bhramaramba Devi Temple", description: "Shakti shrine within Srisailam complex." },
      { name: "Pathala Ganga", description: "Krishna River pilgrimage point below Srisailam." },
      { name: "Srisailam Dam", description: "Major dam and viewpoint." }
    ],
    images: { thumbnailImage: "https://api.blessingsonthenet.com/uploads/f5c7f4e9d88e3724f55bd659a8e057da-1692415377867-Mallikarjuna-Temple%2C-Srisailam411.jpg" },
    management: {
      trustName: "Srisaila Devasthanam",
      website: "https://www.srisailadevasthanam.org/",
      contactNumber: "+91-8333901351; +91-8524-287126"
    }
  },
  {
    slNo: "47",
    slug: "arunachaleswarar-tiruvannamalai",
    generalInfo: {
      templeName: "Arunachaleswarar Temple",
      templeDescription: "Arunachaleswarar Temple in Tiruvannamalai is one of the Pancha Bhoota Sthalams of Shiva, representing the element of fire, and is the focal point of the sacred Arunachala hill. The large temple is administered by Tamil Nadu HR&CE and provides comprehensive pilgrim services. Karthigai Deepam and full-moon Girivalam nights bring exceptional crowds. The traditional Girivalam circuit around Arunachala is roughly 14 km.",
      location: "Tiruvannamalai, Tamil Nadu",
      deity: "Lord Arunachaleswarar (Shiva) and Goddess Unnamulai Amman",
      trekPoints: [],
      dressCode: "Modest clothing covering shoulders and knees recommended."
    },
    timeInfo: {
      bestTime: "November - February",
      peakTime: "Karthigai Deepam and full-moon Girivalam nights"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "29", low: "19" },
        { month: "Feb", high: "31", low: "20" },
        { month: "Mar", high: "34", low: "23" },
        { month: "Apr", high: "36", low: "25" },
        { month: "May", high: "37", low: "26" },
        { month: "Jun", high: "35", low: "26" },
        { month: "Jul", high: "34", low: "25" },
        { month: "Aug", high: "33", low: "25" },
        { month: "Sep", high: "33", low: "25" },
        { month: "Oct", high: "31", low: "24" },
        { month: "Nov", high: "28", low: "22" },
        { month: "Dec", high: "28", low: "20" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:30 AM",
        morningClose: "Open through day",
        eveningOpen: "Open through day",
        eveningClose: "08:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Ushakala Pooja", time: "05:30 AM - 07:00 AM" },
        { name: "Kalasandhi Pooja", time: "08:00 AM - 09:30 AM" },
        { name: "Uchikala Pooja", time: "10:00 AM - 11:30 AM" },
        { name: "Sayaratchai Pooja", time: "05:30 PM - 07:00 PM" },
        { name: "Arthajama Pooja", time: "09:00 PM - 09:30 PM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Chennai International Airport", endPoint: "Tiruvannamalai", distanceKm: 171.8, duration: "Approx. 2.5-4 hrs", cost: "₹4000-₹4800 by taxi" },
      { mode: "Train", startPoint: "Tiruvannamalai Railway Station", endPoint: "Temple", distanceKm: 2, duration: "Approx. 10 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "Anantharaa Hotel, approx. 0.2 km from temple", costRange: "Verify tariff", bookingInfo: "Close to temple." }
    ],
    gates: [
      { name: "East Rajagopuram", description: "Main public darshan entry.", location: "East side", isOpen: true },
      { name: "North Ammani Amman Gopuram", description: "Public darshan entry.", location: "North side", isOpen: true }
    ],
    facilities: [
      { name: "Locker / Cloak Room", description: "Cloakrooms available near East and North entrances.", isAvailable: true },
      { name: "Shoe Stand", description: "Free footwear stands available.", isAvailable: true, price: "Free" },
      { name: "Drinking Water", description: "RO drinking-water facilities available.", isAvailable: true },
      { name: "Toilets", description: "Temple toilets and bathing rooms available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Daily annadanam plus vegetarian restaurants nearby.", isAvailable: true },
      { name: "Wheelchair", description: "Wheelchairs and battery-vehicle assistance available.", isAvailable: true }
    ],
    specialServices: [
      { name: "Girivalam", description: "Approx. 14 km circumambulation of Arunachala Hill." },
      { name: "Special Abhishekam", description: "Special Abhishekam bookable.", price: "₹2,500" }
    ],
    nearbyPlaces: [
      { name: "Sri Ramanasramam", description: "Major ashram on the Girivalam road." },
      { name: "Virupaksha Cave", description: "Sacred cave on Arunachala hill." }
    ],
    images: { thumbnailImage: "https://i.pinimg.com/736x/2d/ba/c9/2dbac9c2437e93df02720450dae93863.jpg" },
    management: {
      trustName: "Arulmigu Arunachaleswarar Temple - Tamil Nadu HR&CE",
      website: "https://annamalaiyar.hrce.tn.gov.in/",
      contactNumber: "04175-252438"
    }
  },
  {
    slNo: "48",
    slug: "palani-murugan-temple",
    generalInfo: {
      templeName: "Palani Dhandayuthapani Swamy Temple",
      templeDescription: "Palani Dhandayuthapani Swamy Temple is one of the six major abodes of Lord Murugan and stands atop Sivagiri Hill in Tamil Nadu. Pilgrims can climb the traditional steps or use the winch and rope-car systems. Free footwear storage, cloakrooms, RO water and toilets are provided at key pilgrim points. Thaipusam and Panguni Uthiram are the busiest festivals.",
      location: "Palani, Dindigul, Tamil Nadu",
      deity: "Lord Dhandayuthapani Swamy (Murugan)",
      trekPoints: [],
      dressCode: "Modest traditional clothing recommended; follow hill-temple dress instructions."
    },
    timeInfo: {
      bestTime: "November - February",
      peakTime: "Thaipusam, Panguni Uthiram and school holidays"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "29", low: "20" },
        { month: "Feb", high: "31", low: "21" },
        { month: "Mar", high: "33", low: "23" },
        { month: "Apr", high: "34", low: "24" },
        { month: "May", high: "33", low: "24" },
        { month: "Jun", high: "30", low: "23" },
        { month: "Jul", high: "29", low: "22" },
        { month: "Aug", high: "29", low: "22" },
        { month: "Sep", high: "30", low: "22" },
        { month: "Oct", high: "29", low: "22" },
        { month: "Nov", high: "27", low: "21" },
        { month: "Dec", high: "27", low: "20" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:45 AM",
        morningClose: "Open through day",
        eveningOpen: "Open through day",
        eveningClose: "08:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Vila Pooja", time: "06:40-07:15 AM" },
        { name: "Kala Sandhi", time: "09:00-09:30 AM" },
        { name: "Uchikkala Pooja", time: "12:00-12:45 PM" },
        { name: "Sayaratchai", time: "05:30-06:15 PM" },
        { name: "Rakkala Pooja", time: "08:30-09:00 PM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Coimbatore International Airport", endPoint: "Palani Temple", distanceKm: 100.9, duration: "Approx. 1.5-2.5 hrs", cost: "₹2300-₹2800 by taxi" },
      { mode: "Train", startPoint: "Palani Railway Station", endPoint: "Hill Base", distanceKm: 2, duration: "Approx. 10 mins", cost: "N/A" },
      { mode: "Winch", startPoint: "Adivaram Winch Station", endPoint: "Hill Temple", distanceKm: 0, duration: "A few minutes", cost: "Approx. ₹100" }
    ],
    accommodation: [
      { type: "Temple Accommodation", location: "Velavan Viduthi, HR&CE", costRange: "From approx. ₹600", bookingInfo: "Book through Palani temple system." }
    ],
    gates: [],
    facilities: [
      { name: "Locker / Cloak Room", description: "Cloakroom available near North Giriveethi.", isAvailable: true },
      { name: "Shoe Stand", description: "Free footwear storage at Adivaram and winch stations.", isAvailable: true, price: "Free" },
      { name: "Drinking Water", description: "RO drinking-water facilities available.", isAvailable: true },
      { name: "Toilets", description: "Temple toilets available at pilgrim points.", isAvailable: true },
      { name: "Prasad", description: "Palani panchamirtham prasad available.", isAvailable: true }
    ],
    specialServices: [
      { name: "Winch Service", description: "Hill transport from Adivaram to the temple.", price: "Approx. ₹100" },
      { name: "Golden Chariot", description: "Bookable temple service on selected dates.", price: "Approx. ₹2,000" }
    ],
    nearbyPlaces: [
      { name: "Thiru Avinankudi Temple", description: "Ancient Murugan shrine at foot of Palani hill." },
      { name: "Idumban Hill", description: "Important Palani pilgrimage point." }
    ],
    images: { thumbnailImage: "https://upload.wikimedia.org/wikipedia/commons/4/43/Palani_Temple-WUS05301.jpg" },
    management: {
      trustName: "Arulmigu Dhandayuthapani Swamy Temple - Tamil Nadu HR&CE",
      website: "https://palanimurugan.hrce.tn.gov.in/",
      contactNumber: "04545-241293"
    }
  },
  {
    slNo: "49",
    slug: "dagdusheth-ganpati-pune",
    generalInfo: {
      templeName: "Shrimant Dagdusheth Halwai Ganpati",
      templeDescription: "Shrimant Dagdusheth Halwai Ganpati in Pune is one of Maharashtra's best-known Ganesh temples, located in the dense historic core near Budhwar Peth. The temple remains open for long daily hours and publishes a structured aarti schedule, with slightly extended hours on Tuesdays. General darshan is free, while several abhishek and yag sevas can be booked for donations. Ganeshotsav and Sankashti dates bring extremely heavy crowds.",
      location: "Pune, Maharashtra",
      deity: "Lord Ganesha",
      trekPoints: [],
      dressCode: "Modest traditional or formal clothing recommended."
    },
    timeInfo: {
      bestTime: "October - February",
      peakTime: "Ganeshotsav, Sankashti Chaturthi and Tuesdays"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "29", low: "15" },
        { month: "Feb", high: "31", low: "17" },
        { month: "Mar", high: "35", low: "19" },
        { month: "Apr", high: "37", low: "21" },
        { month: "May", high: "36", low: "22" },
        { month: "Jun", high: "29", low: "22" },
        { month: "Jul", high: "26", low: "22" },
        { month: "Aug", high: "25", low: "21" },
        { month: "Sep", high: "28", low: "21" },
        { month: "Oct", high: "31", low: "19" },
        { month: "Nov", high: "30", low: "16" },
        { month: "Dec", high: "28", low: "14" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:00 AM",
        morningClose: "Open continuously",
        eveningOpen: "Open continuously",
        eveningClose: "10:30 PM (Tuesday until 11:00 PM)"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Suprabhatam Aarti", time: "07:30-07:45 AM" },
        { name: "Naivedyam Aarti", time: "01:30-01:45 PM" },
        { name: "Mahamangal Aarti", time: "08:00-09:00 PM" },
        { name: "Shej Aarti", time: "10:30-10:45 PM" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Pune International Airport", endPoint: "Dagdusheth Ganpati", distanceKm: 10.6, duration: "Approx. 20-40 mins", cost: "₹450-₹550 by taxi" },
      { mode: "Train", startPoint: "Pune Junction", endPoint: "Dagdusheth Ganpati", distanceKm: 4, duration: "Approx. 15-25 mins", cost: "N/A" }
    ],
    accommodation: [
      { type: "Hotel", location: "Central Pune / Deccan / Shivajinagar", costRange: "Varies", bookingInfo: "Many hotels within a few kilometres." }
    ],
    gates: [],
    facilities: [
      { name: "Shoe Stand", description: "Footwear storage available around temple approach.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available in visitor area.", isAvailable: true },
      { name: "Toilets", description: "Public facilities available in central Pune market area.", isAvailable: true },
      { name: "Restaurants / Food", description: "Keshar Pure Veg and numerous eateries around Budhwar Peth.", isAvailable: true },
      { name: "Prasad", description: "Modak and prasad available through temple counters.", isAvailable: true }
    ],
    specialServices: [
      { name: "Nitya Abhishek", description: "Daily bookable seva.", price: "₹251" },
      { name: "Satyavinayak Pooja", description: "Friday seva.", price: "₹1,100" }
    ],
    nearbyPlaces: [
      { name: "Shaniwar Wada", description: "Historic fortification about 0.5 km away." },
      { name: "Lal Mahal", description: "Historic Pune landmark near the temple." }
    ],
    images: { thumbnailImage: "https://utsav.gov.in/public/uploads/darshan_cover_image/darshan_42/1651224930143200465.jpg" },
    management: {
      trustName: "Shrimant Dagdusheth Halwai Sarvajanik Ganpati Trust",
      website: "https://www.dagdushethganpati.com/",
      contactNumber: "+91-20-24496464; +91-9860620277"
    }
  },
  {
    slNo: "50",
    slug: "trimbakeshwar-nashik",
    generalInfo: {
      templeName: "Trimbakeshwar Jyotirlinga Temple",
      templeDescription: "Trimbakeshwar Temple at Trimbak near Nashik is one of the twelve Jyotirlingas and is closely associated with the source region of the Godavari River and the Brahmagiri hills. The temple trust offers online accommodation, donation darshan and several ritual bookings including Rudrabhishek and Laghu Rudra. Shravan Mondays, Maha Shivaratri and Kumbh-related periods are exceptionally crowded.",
      location: "Trimbak, Nashik, Maharashtra",
      deity: "Lord Trimbakeshwar (Shiva Jyotirlinga)",
      trekPoints: [],
      dressCode: "Modest traditional clothing; dhoti/traditional dress required for certain inner rituals."
    },
    timeInfo: {
      bestTime: "October - March",
      peakTime: "Shravan Mondays, Maha Shivaratri and Kumbh-related periods"
    },
    footfall: { monthlyFootfalls: [] },
    registrationProcess: [],
    prerequisites: [],
    temperature: {
      monthlyTemperatures: [
        { month: "Jan", high: "28", low: "11" },
        { month: "Feb", high: "31", low: "13" },
        { month: "Mar", high: "35", low: "17" },
        { month: "Apr", high: "37", low: "21" },
        { month: "May", high: "36", low: "23" },
        { month: "Jun", high: "30", low: "23" },
        { month: "Jul", high: "27", low: "22" },
        { month: "Aug", high: "27", low: "21" },
        { month: "Sep", high: "29", low: "21" },
        { month: "Oct", high: "31", low: "18" },
        { month: "Nov", high: "30", low: "14" },
        { month: "Dec", high: "28", low: "11" }
      ]
    },
    templeTimings: {
      mandirTimings: {
        morningOpen: "05:30 AM",
        morningClose: "Open through day under normal schedule",
        eveningOpen: "Open through day",
        eveningClose: "09:00 PM"
      },
      gufaTimings: { morningOpen: "N/A", morningClose: "N/A", eveningOpen: "N/A", eveningClose: "N/A" },
      aartis: [
        { name: "Brahma Pooja", time: "Approx. 07:00-08:30 AM" },
        { name: "Midday Pooja", time: "Approx. 10:45 AM - 12:30 PM" },
        { name: "Evening Pooja", time: "Evening ritual window" }
      ]
    },
    transportation: [
      { mode: "Flight", startPoint: "Nashik Airport (Ozar)", endPoint: "Trimbakeshwar", distanceKm: 40, duration: "Approx. 50-60 mins", cost: "N/A" },
      { mode: "Train", startPoint: "Nashik Road Railway Station", endPoint: "Trimbakeshwar", distanceKm: 37.1, duration: "Approx. 35-60 mins", cost: "₹650-₹800 by taxi" },
      { mode: "Taxi", startPoint: "Nashik city", endPoint: "Trimbakeshwar", distanceKm: 29.2, duration: "Approx. 28-45 mins", cost: "₹500-₹650" }
    ],
    accommodation: [
      { type: "Temple Trust Accommodation", location: "Shivprasad Bhaktniwas, Trimbak", costRange: "Tariff varies", bookingInfo: "Near Trimbak bus stand; family accommodation, ID required." }
    ],
    gates: [
      { name: "East Gate", description: "Temple entrance on the east side.", location: "Trimbakeshwar Temple complex", isOpen: true },
      { name: "West Gate", description: "Temple entrance on the west side.", location: "Trimbakeshwar Temple complex", isOpen: true }
    ],
    facilities: [
      { name: "Locker / Cloak Room", description: "Paid cloakroom/storage services available around temple approach.", isAvailable: true },
      { name: "Shoe Stand", description: "Footwear storage available.", isAvailable: true },
      { name: "Drinking Water", description: "Drinking water available in temple-town area.", isAvailable: true },
      { name: "Toilets", description: "Public toilets available.", isAvailable: true },
      { name: "Restaurants / Food", description: "Vegetarian restaurants and bhojanalayas operate around bus stand.", isAvailable: true },
      { name: "Prasad", description: "Temple prasad available.", isAvailable: true }
    ],
    specialServices: [
      { name: "Online Rudrabhishek", description: "Temple trust offers online Rudrabhishek booking.", price: "₹2,100" },
      { name: "Online Laghu Rudra", description: "Temple trust offers online Laghu Rudra booking.", price: "₹21,000" }
    ],
    nearbyPlaces: [
      { name: "Brahmagiri Hill", description: "Sacred hill associated with Godavari source; trek required." },
      { name: "Kushavarta Kund", description: "Sacred kund in Trimbak used for rituals." }
    ],
    images: { thumbnailImage: "https://i.pinimg.com/736x/ae/22/66/ae2266b43d78eca57f890f60ca288a26.jpg" },
    management: {
      trustName: "Shri Trimbakeshwar Devasthan Trust",
      website: "https://trimbakeshwartrust.com/",
      contactNumber: "+91-2594-233215"
    }
  }
];
